export default __webpack_public_path__ + "static/media/landscape3.e87478f0.JPG";